import Backbone from 'backbone/backbone'
import _ from 'underscore/underscore'
import imagesLoaded from 'imagesloaded/imagesloaded.pkgd.min.js'

import ProjectItem from 'front/components/ProjectItem/ProjectItem'
import BaseView from 'front/components/BaseView/BaseView.js'

import './ProjectList.css'
import template from './ProjectList.jinja'


var ProjectList = BaseView.extend({
    apiUrl: '/api/projects/',

    events: {
        'click .ProjectList-btn': 'loadMore'
    },

    initialize () {
        this.state = {
            offset: 0,
            limit: 9
        }

        this.$load = this.$('.ProjectList-btn')
        this.$list = this.$('.ProjectList-list')

        this.views = _.map(this.$el.find('.ProjectItem'), (el) => {
            return new ProjectItem({
                el: $(el)
            })
        })
    },

    add(projects) {
        _.each(projects, (item) => {
            let view = new ProjectItem({
                model: item
            })

            this.$list.append(view.render().el)

            this.views.push(view)
        })
    },

    loadMore() {
        this.$load.find('.BtnLoad').addClass('isLoading')
        let oldH = this.$list.outerHeight()
        $.Velocity.hook(this.$list, 'height', oldH + 'px')

        this.getData()
            .then((data) => {
                this.add(data.projects)

                $.Velocity.hook(this.$list, 'height', 'auto')
                let newH = this.$list.outerHeight()
                $.Velocity.hook(this.$list, 'height', oldH + 'px')

                var $els = $('.ProjectItem.isNotActive')
                var $imgs = $els.find('img')

                imagesLoaded($imgs, () => {
                    this.$load.find('.BtnLoad').removeClass('isLoading')
                    $.Velocity.animate(this.$list[0], {height: newH}, {duration: 1500})
                    $.Velocity.animate(this.$load[0], {opacity: 0})

                    setTimeout(() => {
                        $els.removeClass('isNotActive')

                        if (data.hasMore) {
                            $.Velocity.hook(this.$load, 'opacity', 1)
                        }
                    }, 500)
                })
            })
    },

    getData() {
        return Promise.resolve($.getJSON(this.apiUrl,
            {
                lang: app.data.lang,
                offset: this.state.offset + this.state.limit,
                limit: this.state.limit
            })
            .then((data) => {
                return data
            })
            .fail(() => {
                console.log('Ошибка при загрузке данных.')
            }))
    }
})

export default ProjectList


// WEBPACK FOOTER //
// ./assets/app/front/components/ProjectList/ProjectList.js